import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paymentType'
})
export class PaymentTypePipe implements PipeTransform {

  transform(value: string): string {
    let result = 'Suscripción';
    if (value.toLowerCase().includes('starter')){
      result = 'Starter';
    }
    else if (value.toLowerCase().includes('professional')){
      result = 'Professional';
    }
    else if (value.toLowerCase().includes('premium')){
      result = 'Premium';
    }
    else if (value.toLowerCase().includes('vip')){
      result = 'Vip';
    }
    else if (value.toLowerCase().includes('white')){
      result = 'White Label';
    }

    return result;
  }

}
